import { render, staticRenderFns } from "./areajiaofei.vue?vue&type=template&id=eb4721d2&scoped=true"
import script from "./areajiaofei.vue?vue&type=script&lang=js"
export * from "./areajiaofei.vue?vue&type=script&lang=js"
import style0 from "./areajiaofei.vue?vue&type=style&index=0&id=eb4721d2&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb4721d2",
  null
  
)

export default component.exports